import { Link } from 'react-router-dom'
import { IconWrapper, MenuItemWrapper } from './styles'

interface IProps {
  to: string,
  icon: any,
  text: string,
  active: boolean
}

const MenuItem = (props: IProps) =>
  <Link to={props.to}>
    <MenuItemWrapper
      active={props.active}
    >
      <IconWrapper>
        <img src={props.icon} alt={props.text} />
      </IconWrapper>

      {props.text}
    </MenuItemWrapper>
  </Link>

export default MenuItem
